import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSortZA$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSortZA extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '576db699d8ccadde26badbbec8b293e50a11e209', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '1369072c34104254db11992b646b100d7ebe85c8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '8761798c0795916e7a76cc694a7bb64e65c90f5b', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.91 8.735H14.1l-.23.7a.42.42 0 0 1-.4.29h-1.04a.265.265 0 0 1-.27-.39l1.85-5.06a.4.4 0 0 1 .39-.27h1.2a.4.4 0 0 1 .39.27l1.85 5.06a.265.265 0 0 1-.27.39h-1.04a.4.4 0 0 1-.4-.29zm-8.16-.743h2.284a.4.4 0 0 0 .283-.683L7.283 4.275a.4.4 0 0 0-.566 0L3.683 7.31a.4.4 0 0 0 .283.683H6.25v9.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5zm9.94 9.678v-.77a.36.36 0 0 0-.36-.36h-2.77l2.99-2.73c.1-.097.158-.23.16-.37v-.77a.36.36 0 0 0-.36-.36h-4.62a.36.36 0 0 0-.36.36v.77a.36.36 0 0 0 .36.36h2.73l-2.94 2.73a.5.5 0 0 0-.16.37v.77a.35.35 0 0 0 .35.36h4.62a.36.36 0 0 0 .36-.36M14.46 7.535l.54-1.89.56 1.89z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-sort-z-a", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-sort-z-a"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-sort-z-a":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSortZA$1);
            }
            break;
    } });
}

const CosmosIconSortZA = CosmosIconSortZA$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSortZA, defineCustomElement };
